import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../../Constant";

export default class UserReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      columns: [
        {
          name: "User",
          selector: "userName",
          sortable: true,
        },
        {
          name: "User Type",
          selector: "role[0].name",
          sortable: true,
          center: true,
        },
        {
          name: "Last Login",
          selector: "lastLogin",
          sortable: true,
          center: true,
          cell: (row) => (
            <div className="d-flex">
              {!row.lastLogin ? "-" : <p>{row.lastLogin}</p>}
            </div>
          ),
        },
        {
          name: "Total Courses",
          selector: "totalCourses",
          sortable: true
        },
        {
          name: "Completed Courses",
          selector: "completedCourses",
          sortable: true,
        },
        // {
        //   name: "Options",
        //   selector: "year",
        //   sortable: true,
        //   right: true,
        //   cell: (row) => (
        //     <div className="d-flex justify-content-center">
        //       <Link to={`/admin/reports/user/${row.id}`}>
        //         <i
        //           class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
        //           id={row.id}
        //         ></i>
        //       </Link>
        //     </div>
        //   ),
        // },
      ],
    };
  }
  componentDidMount() {
    this.getUserReports()
  }
  getUserReports = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    // urlencoded.append("userId", localStorage.getItem("lms_uid"));
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    // urlencoded.append("courseId", courseId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/user/userProgress", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          this.setState({ data: result.data })
        }
      })
      .catch((error) => console.log("error", error));
  }
  render() {
    return (
      <div className="py-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /
                  <Link to="/admin/reports">Report</Link> /
                  <Link to="/admin/reports/user">User Report</Link>
                </h5>
              </div>
            </div>

            <div className="text-center">
              <DataTable
                noHeader={true}
                columns={this.state.columns}
                data={this.state.data}
                pagination={true}
                center
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
